import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdi",
  },
  theme: {
    themes: {
      light: {
        primary: "#ececec",
        secondary: "ececec",
        success: "#3cd1c2",
        info: "#f8b006",
        error: "#ff6347",
      },
    },
  },
});
